module.exports = __webpack_public_path__ + "img/guided-morning-meditation.cdb06e42.png";